var botnia2;
(function($) {
  "use strict";
  botnia2 = (function() {
    return {
      init: function() {
        this.regimenForm();
        this.career();
        this.careerForm();
        this.contactForm();
        this.wishlist();
        this.quantity();
        this.collections();
        this.batch();
        this.blog();
        this.cart();
        this.account();
        this.search();
        this.registerForm();
        this.bio();
        this.scrollbar();
        this.locations();
        this.videoParallax();
        this.newsletterPopup();
        this.productVariants();
      },

      isEmail: function(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
      },

      regimenForm: function() {
        $(".js-form-file").click(function () {
          var id = $(this).attr("data-id");
          $("#file" + id).click();
        });
        function convertHeicToJpg(input, element, id)
        {
            var fileName = $(input).val();
            var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
            if(fileNameExt == "heic") {
                var blob = $(input)[0].files[0]; //ev.target.files[0];
                heic2any({
                    blob: blob,
                    toType: "image/jpg",
                })
                    .then(function (resultBlob) {
    
                        var url = URL.createObjectURL(resultBlob);
                        $(".js-form-file[data-id='" + id + "'] img").attr("src", url);
                        //adding converted picture to the original <input type="file">
                        let fileInputElement = $(element)[0];
                        let container = new DataTransfer();
                        let file = new File([resultBlob], "heic"+".jpg",{type:"image/jpeg", lastModified:new Date().getTime()});
                        container.items.add(file);
    
                        fileInputElement.files = container.files;
                        console.log("added");
                    })
                    .catch(function (x) {
                        console.log(x.code);
                        console.log(x.message);
                    });
            }
        }
        $("#file1").on("change", function () {
          var file_img = '';
          var file = document.getElementById("file1").files[0];
          if (file) {
            if(file['name'].indexOf('.heic') != -1) {
              convertHeicToJpg(this, '#file1', 1);
            } else {
              var filereader = new FileReader();
              filereader.readAsDataURL(file);
              filereader.onload = function (evt) {
                 file_img = evt.target.result;
                 $(".js-form-file[data-id='1'] img").attr("src", file_img);
                 $(".js-form-file[data-id='1'] p").eq(0).html("Choose\nother file").css("color", "#fff");
              }
            }
          }
        });
        $("#file2").on("change", function () {
          var file_img = '';
          var file = document.getElementById("file2").files[0];
          if (file) {
            if(file['name'].indexOf('.heic') != -1) {
              convertHeicToJpg(this, '#file2', 2);
            } else {
              var filereader = new FileReader();
              filereader.readAsDataURL(file);
              filereader.onload = function (evt) {
                 file_img = evt.target.result;
                 $(".js-form-file[data-id='2'] img").attr("src", file_img);
                 $(".js-form-file[data-id='2'] p").eq(0).html("Choose\nother file").css("color", "#fff");
              }
            }
          }
        });
        $("#file3").on("change", function () {
          var file_img = '';
          var file = document.getElementById("file3").files[0];
          if (file) {
            if(file['name'].indexOf('.heic') != -1) {
              convertHeicToJpg(this, '#file3', 3);
            } else {
              var filereader = new FileReader();
              filereader.readAsDataURL(file);
              filereader.onload = function (evt) {
                 file_img = evt.target.result;
                 $(".js-form-file[data-id='3'] img").attr("src", file_img);
                 $(".js-form-file[data-id='3'] p").eq(0).html("Choose\nother file").css("color", "#fff");
              }
            }
          }
        });
        $(".js-regimen-form").submit(function () {
          var errors = false;
          if($(".js-first-name").val() == '') {
            $(".js-first-name").addClass("has-error");
            errors = true;
          } else {
            $(".js-first-name").removeClass("has-error");
          }
          if($(".js-last-name").val() == '') {
            $(".js-last-name").addClass("has-error");
            errors = true;
          } else {
            $(".js-last-name").removeClass("has-error");
          }
          if(botnia2.isEmail($(".js-email").val())) {
            $(".js-email").removeClass("has-error");
          } else {
            $(".js-email").addClass("has-error");
            errors = true;
          }
          if($(".js-age").val() == '') {
            $(".js-age").addClass("has-error");
            errors = true;
          } else {
            $(".js-age").removeClass("has-error");
          }
          var describe_your_skin = false;
          $(".js-describe-your-skin").each(function () {
            if($(this).is(":checked")) {
              describe_your_skin = true;
            }
          });
          if(describe_your_skin == false) {
            $(".js-describe-your-skin + span").css("color", "red");
            errors = true;
          } else {
            $(".js-describe-your-skin + span").css("color", "#000");
          }
          if($(".js-tzone-feels").val() == '') {
            $(".js-tzone-feels").addClass("has-error");
            errors = true;
          } else {
            $(".js-tzone-feels").removeClass("has-error");
          }
          var skin_condition = false;
          $(".js-skin-condition").each(function () {
            if($(this).val() != '') {
              skin_condition = true;
            }
          });
          if(skin_condition == false) {
            $(".js-skin-condition").addClass("has-error");
            errors = true;
          } else {
            $(".js-skin-condition").removeClass("has-error");
          }
          var pregnancy = false;
          $(".js-pregnancy").each(function () {
            if($(this).is(":checked")) {
              pregnancy = true;
            }
          });
          if(pregnancy == false) {
            $(".js-pregnancy + span").css("color", "red");
            errors = true;
          } else {
            $(".js-pregnancy + span").css("color", "#000");
          }
          if($(".js-currently-using-products").val() == '') {
            $(".js-currently-using-products").addClass("has-error");
            errors = true;
          } else {
            $(".js-currently-using-products").removeClass("has-error");
          }
          if($(".js-interested-products").val() == '') {
            $(".js-interested-products").addClass("has-error");
            errors = true;
          } else {
            $(".js-interested-products").removeClass("has-error");
          }
          if($(".js-note").is(":checked")) {
            $(".js-note + span").css("color", "#000");
          } else {
            $(".js-note + span").css("color", "red");
            errors = true;
          }
          if(errors == false) {
            $(".js-errors-note").hide();
          } else {
            $(".js-errors-note").show();
          }
          // Fill fields
          $(".js-contact-name").val($(".js-first-name").val() + " " + $(".js-last-name").val());
          $(".js-contact-email").val($(".js-email").val()); 
          var message = "Message from build a customized regimen form.\n\nName: " + $(".js-first-name").val() + " " + $(".js-last-name").val();
          message += "\n";
          message += "Age: " + $(".js-age").val();
          message += "\n\n";
          message += "How would you describe your skin?\nPlease select all that apply:\n";
          $(".js-describe-your-skin").each(function () {
            if($(this).is(":checked")) {
              message += $(this).parent().find("span").html() + "\n";
            }
          });
          message += "\n";
          message += "Run your fingers down the center of your face: are you oily or dry?\nDo you feel bumps under your skin? Let us know how your t-zone feels:\n";
          message += $(".js-tzone-feels").val();
          message += "\n\n";
          message += "Are you currently experiencing any specific skin conditions?\n";
          $(".js-skin-condition").each(function () {
            message += $(this).val() + "\n";
          });
          message += "\n";
          message += "Are you currently pregnant or breastfeeding?\n";
          $(".js-pregnancy").each(function () {
            if($(this).is(":checked")) {
              message += $(this).parent().find("span").html() + "\n";
            }
          });
          message += "\n";
          message += "Please list your current skincare routine / all products you’re currently using.\n";
          message += $(".js-currently-using-products").val();
          message += "\n\n";
          message += "Are you interested in specific products (cleanser, moisturizer, etc.) or building an entire new skincare regimen?\n";
          message += $(".js-interested-products").val();
          message += "\n\n";
          if(errors == false) {
            var id = Math.floor(Math.random() * 10000000000000);
            var file1 = false;
            var file2 = false;
            var file3 = false;
            var file = document.getElementById("file1").files[0];
            if (file) {
              var filereader = new FileReader();
              filereader.readAsDataURL(file);
              filereader.onload = function (evt) {
                 file1 = evt.target.result;
              }
            }
            var file = document.getElementById("file2").files[0];
            if (file) {
              var filereader = new FileReader();
              filereader.readAsDataURL(file);
              filereader.onload = function (evt) {
                 file2 = evt.target.result;
              }
            }
            var file = document.getElementById("file3").files[0];
            if (file) {
              var filereader = new FileReader();
              filereader.readAsDataURL(file);
              filereader.onload = function (evt) {
                 file3 = evt.target.result;
              }
            }
            setTimeout(function () {
              $.post('https://ninethemes.net/botnia/api/upload_images.php', {id: id, file1: file1, file2: file2, file3: file3}, function(response){ 
              });
            }, 7500);
            message += "Uploaded images:\n";
            var file = document.getElementById("file1").files[0];
            if(file) {
              message += "Left side: " + id + "_left.png\n";
            } else {
              message += "Left side: NO IMAGE\n";
            }
            var file = document.getElementById("file2").files[0];
            if(file) {
              message += "Center: " + id + "_center.png\n";
            } else {
              message += "Center: NO IMAGE\n";
            }
            var file = document.getElementById("file3").files[0];
            if(file) {
              message += "Right side: " + id + "_right.png\n";
            } else {
              message += "Right side: NO IMAGE\n";
            }
            message += "\n";
          }
          message += "Is there anything else we should know about your skin and / or your health?\n";
          message += $(".js-more-info-about-health").val();
          $(".js-ask-question-body").val(message);
          if(errors == false) {
            $(".js-form-submit").html("Sending...");
            setTimeout(function () {
              $("#contact_form").submit();
            }, 30000);
            $(".js-uploading-note").show();
            var i = 30;
            $(".js-form-submit").html('Sending... (30s)');
            setInterval(function () {
              i--;
              if(i >= 0) {
                $(".js-form-submit").html('Sending... (' + i + 's)');
              }
            }, 1000);
          }
          return false;
        });
      },

      career: function() {
        $(".js-apply-button").click(function () {
          $("html, body").animate({ scrollTop: $("#open-positions").offset().top - 75 }, 600);
          return false;
        });
      },

      careerForm: function() {
        $(".js-choose-career-file").click(function () {
          $(".js-contact-form input[type='file']").click();
          return false;
        });
        $(".js-contact-form input[type='file']").change(function () {
          $(".js-career-file").html($('.js-contact-form input[type=file]').val().replace(/.*(\/|\\)/, ''));
        });
        $(".js-career-form").submit(function () {
          var errors = false;
          if(!botnia2.isEmail($(this).find(".js-carrer-email").val())) {
            errors = true;
            $(this).find(".js-carrer-email").addClass("has-error");
          } else {
            $(this).find(".js-carrer-email").removeClass("has-error");
          }
          if($(this).find(".js-career-name").val() == '') {
            errors = true;
            $(this).find(".js-career-name").addClass("has-error");
          } else {
            $(this).find(".js-career-name").removeClass("has-error");
          }
          if($(this).find(".js-career-message").val() == '') {
            errors = true;
            $(this).find(".js-career-message").addClass("has-error");
          } else {
            $(this).find(".js-career-message").removeClass("has-error");
          }
          if($(".js-contact-form input[type='file']").val()) {
            $(this).find(".js-career-file-title").css("color", "black");
          } else {
            $(this).find(".js-career-file-title").css("color", "red");
            errors = true;
          }
          if(errors == false) {
            $(".js-contact-name").val($(this).find(".js-career-name").val());
            $(".js-contact-email").val($(this).find(".js-carrer-email").val());
            var id = Math.floor(Math.random() * 10000000000000);
            var file = "\n\nAttached file: " + id + ".pdf";
            var careerFormTitle = $(this).attr("data-title");
            var career = "Career form - " + careerFormTitle + "\n\n";
            $(".js-ask-question-body").val(career + $(this).find(".js-career-message").val() + file);
            $(this).find(".js-send-cv span").html("Sending...");
            setTimeout(function () {
              var fd = new FormData(),
                myFile = document.getElementById("file1").files[0];
              fd.append('file', myFile);
              $.ajax({
                url: "https://ninethemes.net/botnia/api/upload_cv.php?id=" + id,
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST'
              });
            }, 1500);
            setTimeout(function () {
              $(".js-contact-form form").submit();
            }, 8000);
          }
          return false;
        });
      },

      contactForm: function() {
        $(".js-contact-2-form").submit(function () {
          var errors = false;
          if($(".js-contact-2-name").val() == '') {
            errors = true;
            $(".js-contact-2-name").addClass("has-error");
          } else {
            $(".js-contact-2-name").removeClass("has-error");
          }
          if(!botnia2.isEmail($(".js-contact-2-email").val())) {
            errors = true;
            $(".js-contact-2-email").addClass("has-error");
          } else {
            $(".js-contact-2-email").removeClass("has-error");
          }
          if($(".js-contact-2-message").val() == '') {
            errors = true;
            $(".js-contact-2-message").addClass("has-error");
          } else {
            $(".js-contact-2-message").removeClass("has-error");
          }
          if(errors == true) {
            $(".js-contact-2-error").css("display", "block");
          } else {
            $(".js-contact-2-error").css("display", "none");
            $(".js-contact-name").val($(".js-contact-2-name").val());
            $(".js-contact-email").val($(".js-contact-2-email").val());
            var message = "Subject: " + $(".js-contact-2-subject").val() + "\n\n";
            message += "Order number: " + $(".js-contact-2-order-number").val() + "\n\n";
            message += "Message:\n" + $(".js-contact-2-message").val();
            $(".js-ask-question-body").val(message);
            $(".js-contact-form form").submit();
          }
          return false; 
        });
      },

      wishlist: function() {
        $(".js-add-to-wishlist").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var wishlist = localStorage.getItem('wishlist');
          if(wishlist == null) { wishlist = ''; }
          if(wishlist.indexOf(productHandle) >= 0) {
            $(this).find("span").attr("class", "icon-heart filled");
          }
        });
        $("body").on("click", ".js-add-to-wishlist", function () {
          if(!$(this).find("span").hasClass("filled")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).find("span").attr("class", "icon-heart filled");
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            return false;
          }
        });
        if($(".js-wishlist-body").length > 0) {
          var wishlist = localStorage.getItem('wishlist');
          var wishlistContent = '';
          if(wishlist == null) { wishlist = ''; }
          if(wishlist != '') {
            var wishlistProducts = wishlist.split(",");
            for (let i = 0; i < wishlistProducts.length; i++) {
              if(wishlistProducts[i] != '') {
                jQuery.getJSON('/products/' + wishlistProducts[i] + '.js', function (product) {
                  console.log(product);
                  var productHTML = '<div class="col-6 col-md-4 col-lg-4"> <div class="tile-desc mb-80"> <a href="' + product.url + '"> <img src="' + product.featured_image + '" class="tile-img" width="584" height="584" alt=""/> <h4 class="ls-10 text-uppercase text-black">' + product.title + '</h4> </a> <p class="ls-10 price">' + Shopify.formatMoney(product.price) + '</p><div class="product-cta"> <a href="#" class="btn js-add-to-cart-2" data-url="' + product.url + '" data-variant-id="' + product.variants[0].id + '" data-original-text="Add to cart" data-adding-text="Adding..."> <span> Add to cart </span> </a> <a href="#" class="js-delete-product-wishlist" data-product-handle="' + product.handle + '"> <span class="icon-heart filled"></span> </a> </div></div></div>';
                  wishlistContent += productHTML;
                });
              }
            }
          }
          setTimeout(function () {
            if(wishlistContent == '') {
              wishlistContent = '<div class="col-12 wishlist-empty">' + $(".js-wishlist-body").attr("data-wishlist-empty") + '</div>';
              $(".js-wishlist-body").html(wishlistContent);
            } else {
              $(".js-wishlist-body").html(wishlistContent);
            }
          }, 2000);
          $("body").on("click", ".js-delete-product-wishlist", function() {
            $(this).closest(".col-6").remove();
            var productHandle = $(this).attr("data-product-handle");
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts);
            return false;
          });
        }
      },

      quantity: function() {
        $("body").on("click", ".js-quantity-down", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if(q_val_up > 0) {
            $(this).parent().find(".js-quantity-field").val(q_val_up-1).keyup();
          } 
          return false; 
        });
        $("body").on("click", ".js-quantity-up", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find(".js-quantity-field").val(q_val_up+1).keyup(); 
          return false; 
        });
      },

      collections: function() {
        if($(".js-load-collections").length > 0) {
          $(".js-collection").each(function () {
            var href = $(this).attr("data-url");
            var that = $(this);
            $.ajax({
              url: href,
              type: 'GET'
            }).done(function(data) {
              $(that).html($(data).find('.js-collection').html());
              $(".js-collection").css("opacity", "0");
              $(".js-load-collections").hide();
              setTimeout(function () {
                $(".js-collection").animate({opacity: 1}, 500);
              }, 100);
              botnia2.wishlist();
              botnia.hoverImage();
            })
          });
        }
      },

      batch: function() {
        $(".js-batch-form").submit(function () {
          var term = $(this).find(".js-batch-input").val();
          var searchURL = '/search?type=article&q=' + term;
          var url = false;
          $.getJSON(searchURL + '&view=json', function(data) {
            $.each(data.results, function(index, item) {
              if(item.title == term) {
                url = item.url;
              }
            });
          });
          $(this).find(".js-batch-submit span").html($(this).find(".js-batch-submit").attr("data-loading"));
          var that = $(this);
          setTimeout(function () {
            if(url == false) {
              alert($(".js-batch-form").attr("data-empty-text"));
            } else {
              window.location.href = url;
            }
            $(that).find(".js-batch-submit span").html($(that).find(".js-batch-submit").attr("data-done"));
          }, 1000); 
          return false;
        });
      },

      blog: function() {
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $(this).parent().remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
          })
          return false;
        });
      },

      cart: function() {
        $("body").on("input", ".js-cart-note", function () {
          localStorage.setItem('cartNote', $(this).val());
          $.ajax({
            url: '/cart/update.js',
            type: 'POST',
            data: {note: $(this).val()}
          });
        });
        function validateEmail($email) {
          var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
          return emailReg.test( $email );
        }
        function isFutureDate(value) {
          const givenDate = new Date(value);
          const currentDate = new Date();
          if (givenDate.getTime() > currentDate.getTime()) {
            return true;
          } else {
            return false;
          }
        }
        $("body").on("click", ".js-add-to-cart", function () {
          if($("input[name='properties[Recipient email]']").length > 0) {
            if($("input[name='properties[Recipient email]']").val().length > 0) {
              if(validateEmail($("input[name='properties[Recipient email]']").val()) != true) {
                alert("Invalid e-mail!");
                return false;
              }
            }
          }
          var id = $(this).attr("data-variant-id");
          if($(".js-product-variant.active").length > 0) {
            id = $(".js-product-variant.active").attr("data-variant-id");
          }
          if($(this).closest(".js-product-form").length > 0) {
            var quantity = $(this).closest(".js-product-form").find(".js-quantity-field").val();
          } else {
            var quantity = 1;
          }
          $(this).find("span").html($(this).attr("data-adding-text"));
          var items = [];
          var properties = {};
          if($("input[name='properties[Recipient email]']").length > 0) {
            if($("input[name='properties[Recipient email]']").val().length > 0) {
              properties = {'__shopify_send_gift_card_to_recipient': true, 'Recipient email': $("input[name='properties[Recipient email]']").val(), 'Recipient name': $("input[name='properties[Recipient name]']").val(), 'Sender name': $("input[name='properties[Sender name]']").val(), 'Message': $("textarea[name='properties[Message]']").val(), 'Send on': $("input[name='properties[Send on]']").val()};
            } else {
              // properties = {'Recipient email': $("input[name='properties[Recipient email]']").val(), 'Recipient name': $("input[name='properties[Recipient name]']").val(), 'Sender name': $("input[name='properties[Sender name]']").val(), 'Message': $("textarea[name='properties[Message]']").val(), 'Send on': $("input[name='properties[Send on]']").val()};
            }
          }
          var newItem = {'id': id, 'quantity': quantity, 'properties': properties};
          items.push(newItem);
          if($(this).closest(".js-product").find(".js-free-product").length > 0) {
            if($(this).closest(".js-product").find(".js-free-product").is(":checked")) {
              var freeProduct = {'id': $(this).closest(".js-product").find(".js-free-product").attr("data-variant-id"), 'quantity': quantity};
              items.push(freeProduct);
            }
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { items: items },
            success: function() {
              botnia2.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              console.log(response);
              botnia2.refreshCart();
            }
          });
          return false; 
        });
        $("body").on("click", ".js-add-to-cart-2", function () {
          var id = $(this).attr("data-variant-id");
          $(this).find("span").html($(this).attr("data-adding-text"));
          $.ajax({
            url: $(this).attr("data-url"),
            type: 'GET'
          }).done(function(data) {
            var quantity = 1;
            var items = [];
            var newItem = {'id': id, 'quantity': quantity};
            items.push(newItem);
            if($(data).find('.js-free-product').length > 0) {
              var freeProduct = {'id': $(data).find('.js-free-product').attr("data-variant-id"), 'quantity': quantity};
              items.push(freeProduct);
            }
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: { items: items },
              success: function() {
                botnia2.refreshCart();
              },
              error: function(response) {
                var errorMessage = response.responseJSON
                  ? response.responseJSON.description
                  : theme.strings.cartError;
                alert(errorMessage);
                botnia2.refreshCart();
              }
            });
          })
          return false; 
        });
        $("body").on("click", ".js-change-quantity", function() {
          if($(this).attr("data-free-product") != '') {
            var variantId = parseInt($(this).attr("data-variant-id"));
            var quantity = parseInt($(this).attr("data-quantity"));
            $(".js-header-cart").addClass("is-loading");
            var data = { updates: {} };
            data.updates[variantId] = quantity;
            var variantIdFreeProuct = parseInt($(this).attr("data-free-product"));
            if($(this).hasClass("icon-plus")) {
              if($(".js-change-quantity[data-variant-id='" + variantIdFreeProuct + "'].icon-plus").length > 0) {
                data.updates[variantIdFreeProuct] = parseInt($(".js-change-quantity[data-variant-id='" + variantIdFreeProuct + "'].icon-plus").attr("data-quantity"));
              }
            } else {
              if($(".js-change-quantity[data-variant-id='" + variantIdFreeProuct + "'].icon-minus").length > 0) {
                data.updates[variantIdFreeProuct] = parseInt($(".js-change-quantity[data-variant-id='" + variantIdFreeProuct + "'].icon-minus").attr("data-quantity"));
              }
            }
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              dataType: 'json',
              data: data,
              success: function() {
                botnia2.refreshCart();
              },
              error: function(response) {
                var errorMessage = response.responseJSON
                  ? response.responseJSON.description
                  : theme.strings.cartError;
                alert(errorMessage);
                botnia2.refreshCart();
              }
            });
            return false;
          } else {
            var variantId = parseInt($(this).attr("data-variant-id"));
            var quantity = parseInt($(this).attr("data-quantity"));
            $(".js-header-cart").addClass("is-loading");
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: { id: variantId, quantity: quantity },
              success: function() {
                botnia2.refreshCart();
              },
              error: function(response) {
                var errorMessage = response.responseJSON
                  ? response.responseJSON.description
                  : theme.strings.cartError;
                alert(errorMessage);
                botnia2.refreshCart();
              }
            });
            return false;
          }
        });
        $("body").on("click", ".js-remove-product", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = parseInt($(this).attr("data-quantity"));
          $(".js-header-cart").addClass("is-loading");
          var data = { updates: {} };
          data.updates[variantId] = quantity;
          var variantIdFreeProuct = parseInt($(this).attr("data-free-product"));
          if($(".js-remove-product-2[data-variant-id='" + variantIdFreeProuct + "']").length > 0) {
            var productQuantity = parseInt($(this).attr("data-total-quantity"));
            var freeProductQuantity = parseInt($(".js-remove-product-2[data-variant-id='" + variantIdFreeProuct + "']").attr("data-total-quantity"));
            var newQuantity = 0;
            if(freeProductQuantity > productQuantity) {
              newQuantity = freeProductQuantity - productQuantity;
            }
            data.updates[variantIdFreeProuct] = parseInt(newQuantity);
          }
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: data,
            success: function() {
              botnia2.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              botnia2.refreshCart();
            }
          });
          return false;
        });
        var interval = setInterval(function () {
          if($(".js-max-product-quantity").length > 0) {
            $(".js-max-product-quantity").each(function () {
              if(!$(this).hasClass("loading")) {
                 $(this).addClass("loading");
                 var quantity = $(this).attr("data-quantity");
                 var variantId = $(this).attr("data-variant-id");
                 if(quantity > 1) {
                  $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: { id: variantId, quantity: 1 },
                    success: function() {
                      botnia2.refreshCart();
                    },
                    error: function(response) {
                      var errorMessage = response.responseJSON
                        ? response.responseJSON.description
                        : theme.strings.cartError;
                      alert(errorMessage);
                      botnia2.refreshCart();
                    }
                  });
                 }
              }
            }); 
          }
        }, 1000);
      },

      refreshCart: function() {
        $('#cart-content').load('/cart #cart-content', function() {
          if(!$(".js-header-cart").hasClass("active")) {
            $("._show-cart").eq(0).click();
          }
          $(".js-add-to-cart, .js-add-to-cart-2").each(function () {
            $(this).find("span").html($(this).attr("data-original-text"));
          });
          $(".js-header-cart").removeClass("is-loading");
          $(".js-reorder").each(function () {
            $(this).find("span").html($(this).attr("data-original-text"));
          });
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('.js-cart-counter').html(cart.item_count);
        });
      },

      account: function() {
        $(".js-go-to-recover-password").click(function () {
          $(".js-login").addClass("d-none");
          $(".js-recover-password").removeClass("d-none");
          return false;
        });
        $(".js-reorder").click(function () {
          $(this).find("span").html($(this).attr("data-loading-text"));
          var items = [];
          $(this).closest(".js-order-products").find(".js-order-product").each(function () {
            var newItem = {'id': $(this).attr("data-variant-id"), 'quantity': $(this).attr("data-quantity")};
            items.push(newItem);
          });
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { items: items },
            success: function() {
              botnia2.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              botnia2.refreshCart();
            }
          });
          return false;
        });
      },

      search: function() {
        $(".js-search-form").submit(function () {
          var term = $(".js-search-input").val();
          var type = 'product';
          if($(".js-change-search-category.active").attr("data-category") != 'Products') {
            type = 'article';
          }
          var searchURL = '/search?type=' + type + '&q=' + term;
          window.location.href = searchURL;          
          return false;
        });
        $(".js-change-search-category").click(function () {
          $(".js-change-search-category").removeClass("active").addClass("btn-outline");
          $(this).addClass("active").removeClass("btn-outline");
          return false;
        });
      },

      registerForm: function() {
        $(".js-go-to-register").click(function () {
          $('html, body').animate({
            scrollTop: $("#start-register").offset().top - 150
          }, 500);
          return false;
        });
        $(".js-register-form").submit(function () {
          var errors = false;
          if($(".js-first-name").val() == '') {
            errors = true;
            $(".js-first-name").addClass("has-error");
          } else {
            $(".js-first-name").removeClass("has-error");
          }
          if($(".js-last-name").val() == '') {
            errors = true;
            $(".js-last-name").addClass("has-error");
          } else {
            $(".js-last-name").removeClass("has-error");
          }
          if($(".js-company-name").val() == '') {
            errors = true;
            $(".js-company-name").addClass("has-error");
          } else {
            $(".js-company-name").removeClass("has-error");
          }
          if(botnia2.isEmail($(".js-email").val())) {
            $(".js-email").removeClass("has-error");
          } else {
            $(".js-email").addClass("has-error");
            errors = true;
          }
          if($(".js-feature:checked").length > 0) {
            $(".js-feature + span").css("color", "black");
          } else {
            errors = true;
            $(".js-feature + span").css("color", "red");
          }
          if($(".js-business-located").val() == '') {
            errors = true;
            $(".js-business-located").addClass("has-error");
          } else {
            $(".js-business-located").removeClass("has-error");
          }
          if($(".js-applied-before:checked").length < 1) {
            errors = true;
            $(".js-applied-before + span").css("color", "red");
          } else {
            $(".js-applied-before + span").css("color", "black");
          }
          var name = $(".js-first-name").val() + ' ' + $(".js-last-name").val();
          $(".js-contact-name").val(name);
          var phone = $(".js-phone").val();
          $(".js-contact-phone").val(phone);
          var email = $(".js-email").val();
          $(".js-contact-email").val(email);
          var message = 'Company Name: ' + $(".js-company-name").val() + '\n';
          message += 'Website Address: ' + $(".js-website-address").val() + '\n';
          message += 'Instagram url: ' + $(".js-instagram-url").val() + '\n\n';
          $(".js-feature").each(function () {
            if($(this).is(":checked")) {
              message += $(this).parent().find("span").html() + '\n';
            }
          });
          message += '\nHow did you hear about Botnia / who referred you?\n';
          message += $(".js-hear-referred").val() + '\n\n';
          message += 'What’s your vision for this partnership?\n';
          message += $(".js-vision-partnership").val() + '\n\n';
          message += 'What’s your vision for your business?\n';
          message += $(".js-vision-business").val() + '\n\n';
          message += 'Where is your business located (City & State)? *\n';
          message += $(".js-business-located").val() + '\n\n';
          message += 'Have you applied for a wholesale account with Botnia before? *\n';
          message += $(".js-applied-before:checked").parent().find("span").html() + '\n\n';
          message += 'Are you interested in…\n';
          $(".js-interested-in").each(function () {
            if($(this).is(":checked")) {
              message += $(this).parent().find("span").html() + '\n';
            }
          });
          $(".js-ask-question-body").val(message);
          if(errors == false) {
            localStorage.setItem('email', email);
            localStorage.setItem('name', name);
            $(".js-errors-note").hide();
            $(".js-contact-form form").submit();
          } else {
            $(".js-errors-note").show();
          }
          return false;
        }); 
        if($(".js-wholesale-form-success").length > 0) {
          var fd = new FormData();
          fd.append('email', localStorage.getItem('email'));
          fd.append('name', localStorage.getItem('name'));
          $.ajax({
            url: "https://ninethemes.net/botnia/api/wholesale_form.php",
            data: fd,
            processData: false,
            contentType: false,
            type: 'POST'
          });
        }
      },

      bio: function() {
        $("body").on("click", ".js-open-bio", function () {
          $(".js-bio").removeClass("active");
          var index = $(this).attr("data-id");
          $(".js-bio[data-id='" + index + "']").addClass("active");
          $("body").css("overflow", "hidden");
          return false;
        });
        $("body").on("click", ".js-close-bio", function () {
          $(".js-bio").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });
      },

      scrollbar: function() {
        $('.js-scrollbar').scrollbar();
      },

      locations: function() {
        $(".js-location").each(function () {
          $(this).appendTo(".js-locations-row");
        });
        $(".js-go-to-locations a").click(function () {
          $(".js-go-to-locations a").removeClass("active");
          $(this).addClass("active");
          var location = $.trim($(this).find("p").html().toLowerCase().replace("-", "").replace("–", ""));
          $(".js-location").each(function () {
            var title1 = $.trim($(this).find(".js-location-subtitle").html().toLowerCase().replace("-", "").replace("–", ""));
            var title2 = $.trim($(this).find(".js-location-subtitle-2").html().toLowerCase().replace("-", "").replace("–", ""));
            var found = false;
            if(title1.indexOf(location) >= 0) {
              found = true
            }
            if(title2.indexOf(location) >= 0) {
              found = true
            }
            if(found == true) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
          $('html, body').animate({
            scrollTop: $("#start-locations").offset().top - 100
          }, 500);
          return false;
        });
      },

      videoParallax: function() {
        if($("#scrolly-video").length > 0) {
          new ScrollyVideo({
            scrollyVideoContainer: "scrolly-video",
            src: $("#scrolly-video").attr("data-video-url")
          });
        }
      },

      newsletterPopup: function() {
        if($(".js-popup-newsletter").length > 0) {
          if(!$.cookie('newsletter')) {
            setTimeout(function () {
              $(".js-popup-newsletter").addClass("active");
            }, $(".js-popup-newsletter").attr("data-show-after"));
          } else {
            $(".js-popup-newsletter").hide();
          }

          $(".js-close-popup-newsletter").click(function () {
            var expires = new Date();
            expires.setMinutes( expires.getMinutes() + 60 );
            $.cookie('newsletter', 'true', { expires : expires });
            $(".js-popup-newsletter").removeClass("active");
            return false;
          });
        }
      },

      productVariants: function() {
        $(".js-product-variant").click(function () {
          $(".js-product-variant").removeClass("active");
          $(this).addClass("active");
          $(".js-product-price").html($(this).attr("data-variant-price"));
          return false;
        }); 
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  botnia2.init();
});